import { render, staticRenderFns } from "./packages.vue?vue&type=template&id=85832b3c&scoped=true&"
import script from "./packages.vue?vue&type=script&lang=js&"
export * from "./packages.vue?vue&type=script&lang=js&"
import style0 from "./packages.vue?vue&type=style&index=0&id=85832b3c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85832b3c",
  null
  
)

export default component.exports